import { Dialog } from 'primereact/dialog';
import { useEffect, useState } from 'react';
import { downloadDeckblatt, downloadFile } from '../../services/All';

interface ComponentProps {
  close: () => void;
  fileUid: string | undefined;
  deckblattAuftragUid: string | undefined;
  dialogVisible: boolean;
}

/**
 * PDF Vorschau Dialog
 */
const DialogPdfComponent: React.FC<ComponentProps> = ({ close, fileUid, deckblattAuftragUid, dialogVisible }) => {

  const [blobUrl, setBlobUrl] = useState<string>();

  useEffect(() => {

  }, [deckblattAuftragUid]);

  useEffect(() => {
    if (!fileUid) return;

    let url: string;

    const fetchPdf = async () => {
      try {
        const resp = await downloadFile(fileUid);
        const blob = new Blob([resp.data], { type: 'application/pdf' });
        url = URL.createObjectURL(blob);
        setBlobUrl(url);
      } catch (error) {
        console.error('Fehler beim Laden der PDF:', error);
        setBlobUrl(undefined);
      }
    };

    fetchPdf();

    // Cleanup: ObjectURL freigeben
    return () => {
      if (url) URL.revokeObjectURL(url);
    };
  }, [fileUid]);

  useEffect(() => {
    if (dialogVisible && fileUid) {
      let url: string;

      const fetchPdf = async () => {
        try {
          const resp = await downloadFile(fileUid);
          const blob = new Blob([resp.data], { type: 'application/pdf' });
          url = URL.createObjectURL(blob);
          setBlobUrl(url);
        } catch (error) {
          console.error('Fehler beim Laden der PDF:', error);
          setBlobUrl(undefined);
        }
      };

      fetchPdf();

      // Cleanup: ObjectURL freigeben
      return () => {
        if (url) URL.revokeObjectURL(url);
      };
    }

    if (dialogVisible && deckblattAuftragUid) {

      let url: string;

      const fetchPdf = async () => {
        try {
          const resp = await downloadDeckblatt(deckblattAuftragUid);
          const blob = new Blob([resp.data], { type: 'application/pdf' });
          url = URL.createObjectURL(blob);
          setBlobUrl(url);
        } catch (error) {
          console.error('Fehler beim Laden der PDF:', error);
          setBlobUrl(undefined);
        }
      };

      fetchPdf();

      // Cleanup: ObjectURL freigeben
      return () => {
        if (url) URL.revokeObjectURL(url);
      };
    }
  }, [dialogVisible]);

  return (
    <Dialog
      visible={dialogVisible}
      onHide={close}
      header="PDF Vorschau"
      modal
      style={{ width: '90vw', height: '90vh' }}
    >
      {blobUrl ? (
        <iframe
          src={blobUrl}
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        />
      ) : (
        <div>PDF wird geladen...</div>
      )}
    </Dialog>
  );
};

export default DialogPdfComponent;
